import { Link } from "react-router-dom";

export const ProgressBar = ({ wb, rating, onShowReviews }) => (
  <div style={{ marginTop: "auto" }}>
    {rating && rating.totalRatings > 0 && (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ color: "#D97706", fontSize: 13 }}>★</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a" }}>
            {rating.avgRating.toFixed(1)}
          </span>
          <span
            style={{ fontSize: 12, color: "#9a8f7e", whiteSpace: "nowrap" }}
          >
            ({rating.totalRatings} rating{rating.totalRatings !== 1 ? "s" : ""})
          </span>
        </div>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onShowReviews();
          }}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            fontSize: 12,
            color: "#2563eb",
            cursor: "pointer",
            fontFamily: "inherit",
            fontWeight: 500,
            whiteSpace: "nowrap",
            marginLeft: "auto",
          }}
        >
          Reviews →
        </button>
      </div>
    )}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: 11,
        color: "#9a8f7e",
        marginBottom: 5,
      }}
    >
      <span>Progress</span>
      {wb.isComplete ? (
        <span style={{ color: "#059669", fontWeight: 600 }}>✓ Complete</span>
      ) : (
        <span style={{ color: "#D97706", fontWeight: 600 }}>
          {wb.progressPercent || 0}%
        </span>
      )}
    </div>
    <div style={{ height: 3, background: "#f0e8dc", borderRadius: 99 }}>
      <div
        style={{
          height: "100%",
          borderRadius: 99,
          background: wb.isComplete ? "#059669" : "#D97706",
          width: `${wb.progressPercent || 0}%`,
          transition: "width .4s",
        }}
      />
    </div>
  </div>
);

export const WorkbookCard = ({
  wb,
  chLabel,
  note,
  noteStyle,
  accentColor,
  locked,
  rating,
  onShowReviews,
  badge,
  useNoteWhenLocked = false,
}) => {
  const effectiveAccent = locked ? "#ddd4c2" : accentColor;

  const containerStyle = {
    background: locked ? "#faf8f5" : "#fff",
    border: "1px solid #e8e0d0",
    borderRadius: 8,
    padding: "1.25rem 1.25rem 1rem 1.5rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all .2s",
  };
  const accentStripStyle = {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    background: effectiveAccent,
  };
  const chLabelStyle = {
    fontSize: 10,
    color: "#c4b9a8",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginBottom: ".6rem",
  };
  const titleStyle = {
    fontFamily: "'Fraunces', serif",
    fontSize: 15,
    fontWeight: 700,
    color: "#1a1a1a",
    lineHeight: 1.3,
    marginBottom: ".4rem",
  };
  const subtitleStyle = {
    fontSize: 11,
    color: "#9a8f7e",
    fontStyle: "italic",
    marginBottom: ".6rem",
  };
  const noteBoxStyle = {
    display: "flex",
    gap: 6,
    background: noteStyle === "green" ? "#f0fdf4" : "#f5f0e8",
    borderRadius: 4,
    padding: "7px 9px",
    marginBottom: ".75rem",
    ...(noteStyle === "green" ? { border: "1px solid #BBF7D0" } : {}),
  };
  const noteTextStyle = {
    fontSize: 11,
    color: noteStyle === "green" ? "#14532d" : "#7a6e60",
    lineHeight: 1.5,
  };
  const sectionCountStyle = {
    fontSize: 11,
    color: "#b8ad9e",
    marginBottom: ".75rem",
  };
  const lockedFooterStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: ".75rem",
    paddingTop: ".75rem",
    borderTop: "1px solid #f0e8dc",
  };

  return (
    <Link to={`/workbooks/${wb.slug}`} style={{ textDecoration: "none" }}>
      <div
        style={containerStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.08)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <div style={accentStripStyle} />
        <div style={chLabelStyle}>{chLabel}</div>
        {badge && (
          <div
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: "#059669",
              background: "#ECFDF5",
              padding: "2px 8px",
              borderRadius: 99,
              border: "1px solid #BBF7D0",
              display: "inline-block",
              marginBottom: 8,
            }}
          >
            {badge}
          </div>
        )}
        <div style={titleStyle}>{wb.title}</div>
        <div style={subtitleStyle}>{wb.subtitle}</div>
        {locked ? (
          <>
            {note && (
              <div style={noteBoxStyle}>
                <span style={{ fontSize: 12, flexShrink: 0 }}>{note.icon}</span>
                <span style={noteTextStyle}>{note.text}</span>
              </div>
            )}
            <div style={lockedFooterStyle}>
              <span style={{ fontSize: 11, color: "#b8ad9e" }}>
                {wb.sectionCount} sections
              </span>
              <span style={{ fontSize: 11, fontWeight: 600, color: "#D97706" }}>
                🔒 Locked
              </span>
            </div>
          </>
        ) : (
          <>
            {note && (
              <div style={noteBoxStyle}>
                <span style={{ fontSize: 12, flexShrink: 0 }}>{note.icon}</span>
                <span style={noteTextStyle}>{note.text}</span>
              </div>
            )}
            <div style={sectionCountStyle}>
              {wb.sectionCount} sections · {wb.estimatedMinutes} min
            </div>
            <ProgressBar
              wb={wb}
              rating={rating}
              onShowReviews={onShowReviews}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <span
                style={{ fontSize: 12, fontWeight: 600, color: accentColor }}
              >
                {wb.isComplete
                  ? "Revisit →"
                  : wb.progressPercent > 0
                    ? "Continue →"
                    : "Read →"}
              </span>
            </div>
          </>
        )}
      </div>
    </Link>
  );
};
